import { FC } from 'react';

import { AppStoreBadge } from '@rikstv/play-common/src/components/appstore/AppStoreBadge';
import { PlayStoreBadge } from '@rikstv/play-common/src/components/appstore/PlayStoreBadge';
import { Link } from '@rikstv/play-common/src/router/Link';
import { getAppLink, isAndroid, isIOS } from '@rikstv/play-common/src/utils/device/device.utils';
import { Bold, H2 } from '@rikstv/shared-components';

import { PlayerErrorContainer } from '../PlayerErrorContainer/PlayerErrorContainer';

import styles from './UnsupportedBrowser.module.css';

const FirefoxLink: FC = () => (
  <Link to="https://www.mozilla.org/firefox/new/" className={styles.unsupportedBrowserLink}>
    Firefox
  </Link>
);
const ChromeLink: FC = () => (
  <Link to="https://www.google.com/chrome/" className={styles.unsupportedBrowserLink}>
    Google Chrome
  </Link>
);

const isMobile = isIOS || isAndroid;

const AppStoreLink: FC = () => {
  const appLink = getAppLink();

  return (
    <span style={{ marginTop: '1rem' }}>
      {isIOS ? <AppStoreBadge href={appLink} /> : <PlayStoreBadge href={appLink} />}
    </span>
  );
};

export const UnsupportedBrowser: FC = () => (
  <PlayerErrorContainer>
    <H2>Vi støtter dessverre ikke avspilling i denne nettleseren.</H2>
    {isMobile ? (
      <AppStoreLink />
    ) : (
      <Bold>
        Vi støtter blant annet <ChromeLink /> og <FirefoxLink />.
      </Bold>
    )}
  </PlayerErrorContainer>
);
